module.exports = __webpack_public_path__ + "static/media/Blazor.f0f72abf.png";